import Loading from "components/loading";
import { forwardRef, ReactNode } from "react";
import { Container, IconButtonStyleType } from "./styles";

type IconButtonType = IconButtonStyleType & {
  icon: ReactNode;
  name?: string;
  className?: string;
  $loading?: boolean;
  onClick?: () => void;
};

const IconButton = forwardRef<HTMLButtonElement, IconButtonType>(
  ({ icon, name, onClick, $loading = false, $disabled, ...args }, ref) => {
    return (
      <Container
        ref={ref}
        title={name}
        onClick={() => !$disabled && onClick?.()}
        $disabled={$disabled}
        {...args}
      >
        {$loading ? <Loading /> : icon}
      </Container>
    );
  }
);

export default IconButton;
